export default __webpack_public_path__ + "static/media/wotfard-regular-webfont.46881ba2.woff2";